import React from "react";
import { Card, Group, Image } from "@mantine/core";
import { format } from "date-fns";
import Title from "../../../Elements/Title/Title";

interface DefaultCardProps {
  item: {
    id: number;
    category: { id: number; name: string };
    title: string;
    description: string;
    imageUrl: string;
    author: string | null;
    created: string;
  };
}

const DefaultCard: React.FC<DefaultCardProps> = ({ item }) => (
  <Card
    padding="md"
    radius="md"
    withBorder
    className="!rounded-2xl !bg-[#131316] !border-[#2f2f31] gap-4"
  >
    {item.imageUrl && (
      <Card.Section className="p-6">
        <Image src={item.imageUrl} className="!rounded-xl max-h-[20rem]" />
      </Card.Section>
    )}
    <Group justify="space-between">
      <Title title={item.category.name} className="!mb-0"></Title>
      {!item.author && (
        <div className="text-right text-[#9e9e9f] text-sm font-medium uppercase">
          {format(new Date(item.created), "HH:mm, dd.MM.yyyy.")}
        </div>
      )}
    </Group>
    {item.author && (
      <Group justify="space-between">
        <div>
          <span className="text-[#9e9e9f] text-sm font-medium">By </span>
          <span className="text-neutral-50 text-sm font-medium">
            {item.author}
          </span>
        </div>
        <div className="text-right text-[#9e9e9f] text-sm font-medium uppercase">
          {format(new Date(item.created), "HH:mm, dd.MM.yyyy.")}
        </div>
      </Group>
    )}
    {item.title && (
      <div className="text-neutral-50 text-base font-bold">{item.title}</div>
    )}
    {item.description && (
      <div>
        <span className="text-neutral-50 text-sm font-medium">
          {item.description}
        </span>
      </div>
    )}
  </Card>
);

export default DefaultCard;
